import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_BANKS](state, data) {
    state.allBanks = data
  },
}
